import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

var i18n;
const loadedLanguages = [];
export const availableLanguages = ['en', 'fr', 'it', 'pl', 'pt-br', 'sp'];
export const currentLanguage = window.locale || 'en';

export function initI18n() {
    return loadLanguage(currentLanguage)
        .then(messages => {
            i18n = new VueI18n({
                locale: currentLanguage,
                fallbackLocale: currentLanguage,
                messages: { [currentLanguage]: messages },
                silentTranslationWarn: true,
            });

            return i18n;
        });
}

function setLanguage (lang) {
    i18n.locale = lang;
    return Promise.resolve();
}

export function loadLanguage (lang) {
    if (i18n && i18n.locale === lang) {
        return;
    }

    if (loadedLanguages.includes(lang)) {
        return setLanguage(lang);
    }

    return import(/* webpackChunkName: "lang-[request]" */ `../lang/${lang}.json`)
        .then(messages => {
            loadedLanguages.push(lang);

            if (i18n) {
                i18n.setLocaleMessage(lang, messages.default);
                return setLanguage(lang);
            }

            return Promise.resolve(messages.default);
        });
}
